import React from "react";
import { Route, Redirect } from "react-router-dom";

export default function PrivateRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={() => {
        return sessionStorage.getItem("user") ? (
          children
        ) : (
          <Redirect to='/login'></Redirect>
        );
      }}
    ></Route>
  );
}
